import { default as default2 } from "./src/features/stringAttribute.js";
import { default as focusVisiblePoly } from "./src/features/focus-visible-poly.js";
import { default as default3 } from "./src/features/cachedValue.js";
export * from "./src/features/html.js";
import { applyToggleAttributePolyFill } from "./src/features/toggleAttributePolyfill.js";
import { isRTL } from "./src/features/isRTL.js";
import * as ResizeListener from "./src/features/resizeListener.js";
import * as RTLObserver from "./src/features/rtlObserver.js";
import * as PredefinitionPropertyHandler from "./src/features/preDefinitionProperties.js";
import { prefixReplacer } from "./src/features/prefixReplacer.js";
import * as SlotTools from "./src/features/evaluateSlot.js";
import * as BreakpointInfo from "./src/features/breakpointInfo.js";
import { CustomPrefixRegistry } from "./src/features/customPrefixRegistry.js";
import {
  registerIcon
} from "./src/features/registerIcon.js";
const DEFAULT_PREFIX = "skapa";
const tagNames = /* @__PURE__ */ new Map();
const requestQueue = new Array();
class SkapaPrefixService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(prefix, setPrefixCallback = () => {
  }) {
    this.inited = false;
    this.__prefix = DEFAULT_PREFIX;
    this.__prefixSet = false;
    // This pattern will find each 'skapa-' that are not preceeded by "-" (to ignore css variables) and not preceeded by "[" (to ignore attribute names).
    this.pattern = /(?:([^-\[\.])|^)skapa-/g;
    this.prefixReplacer = (rawHTML) => {
      return rawHTML.replace(this.pattern, `$1${this.prefix}-`);
    };
    this.html = (strings, ...values) => this.prefixReplacer(String.raw({ raw: strings }, ...values));
    this.setPrefixCallback = setPrefixCallback;
    if (prefix) {
      this.prefix = prefix;
    }
  }
  get prefix() {
    this.inited = true;
    return this.__prefix;
  }
  set prefix(val) {
    if (this.inited && this.__prefix !== val)
      console.error(
        "Skapa Web components tag prefix was set after init!\nMake sure to set the prefix **before** initialising any of the skapa web components"
      );
    this.__prefix = val;
    this.__prefixSet = true;
    this.setPrefixCallback();
  }
}
const skapaPrefixService = new SkapaPrefixService(void 0, () => {
  requestQueue.forEach((quedItem) => {
    if ("tag" in quedItem && "skapaElementClass" in quedItem) {
      registerSkapaElement(quedItem.tag, quedItem.skapaElementClass);
    } else {
      registerSkapaElement(quedItem);
    }
  });
  requestQueue.length = 0;
});
function registerSkapaElement(tagNameOrSkapaElementClass, skapaElementClass) {
  if (typeof tagNameOrSkapaElementClass === "string" && skapaElementClass) {
    const prefixedTagName = `${config.prefix}-${tagNameOrSkapaElementClass}`;
    if (typeof window !== "undefined") {
      const defined = customElements.get(prefixedTagName);
      if (defined) {
        if (defined !== skapaElementClass || Object.getPrototypeOf(defined) !== skapaElementClass) {
          console.error(
            `Skapa Web Component!
"${prefixedTagName}": Different versions using the same name. Please set a unique prefix or update your Skapa web component dependency versions.`
          );
        }
      } else {
        customElements.define(prefixedTagName, skapaElementClass);
        tagNames.set(skapaElementClass, prefixedTagName);
      }
      return prefixedTagName;
    }
  }
  const modernSkapaElementClass = tagNameOrSkapaElementClass;
  const tagName = `${config.prefix}-${modernSkapaElementClass.skapaTagName}`;
  modernSkapaElementClass.skapaIconDependencies.forEach((icon) => {
    registerIcon(icon);
  });
  modernSkapaElementClass.skapaDependencies.forEach(registerSkapaElement);
  const registeredTagName = tagNames.get(modernSkapaElementClass);
  if (registeredTagName)
    return registeredTagName;
  if (typeof window !== "undefined") {
    const defined = customElements.get(tagName);
    if (defined) {
      if (defined !== skapaElementClass || Object.getPrototypeOf(defined) !== skapaElementClass) {
        console.error(
          `Skapa Web Component!
"${tagName}": Different versions using the same name. Please set a unique prefix or update your Skapa web component dependency versions.`
        );
      }
    } else {
      customElements.define(tagName, modernSkapaElementClass);
      tagNames.set(modernSkapaElementClass, tagName);
    }
  } else {
  }
  return tagName;
}
const config = skapaPrefixService;
function registerRequest(tagNameOrSkapaElementClass, legacyClass) {
  if (typeof tagNameOrSkapaElementClass === "string") {
    if (!legacyClass) {
      throw new Error(
        "Legacy registration request must provide a custom element class"
      );
    }
    if (config.__prefixSet) {
      registerSkapaElement(tagNameOrSkapaElementClass, legacyClass);
    } else {
      requestQueue.push({
        tag: tagNameOrSkapaElementClass,
        skapaElementClass: legacyClass
      });
    }
    return () => getTagFor(legacyClass);
  }
  if (config.__prefixSet) {
    registerSkapaElement(tagNameOrSkapaElementClass);
  } else {
    requestQueue.push(tagNameOrSkapaElementClass);
  }
  return () => getTagFor(tagNameOrSkapaElementClass);
}
var tools_default = registerRequest;
function getTagFor(customElementConstructor) {
  if (!config.__prefixSet) {
    console.error(
      "Requested custom element tag name before the custom prefix was set.\nMake sure the prefix is set in the configuration prior."
    );
  }
  const tagName = tagNames.get(customElementConstructor);
  if (!tagName) {
    console.error(
      `Requesting tag name for an unregistered custom element!
Make sure you register the element: ${customElementConstructor.name} before using it.`
    );
  }
  return tagName || "";
}
applyToggleAttributePolyFill();
focusVisiblePoly();
setTimeout(() => {
  if (!config.__prefixSet) {
    config.prefix = DEFAULT_PREFIX;
  }
});
export {
  BreakpointInfo,
  default3 as CachedValue,
  CustomPrefixRegistry,
  PredefinitionPropertyHandler,
  RTLObserver,
  ResizeListener,
  SkapaPrefixService,
  SlotTools,
  config,
  tools_default as default,
  getTagFor,
  isRTL,
  prefixReplacer,
  registerRequest,
  skapaPrefixService,
  default2 as stringAttribute
};
